import { useEffect } from 'react';
import styles from './ArtworkLargeView.module.scss';
import { ReactComponent as CloseIconPressed } from '../../../assets/images/close.svg';
import Button2 from '../../Buttons/Button2/Button2';
import { preventMultiClickSelection } from '../../../utils/selection';
import { useOverlay } from '../../../utils/overlays';

// const ARTWORK_SIZE = 600;
const ARTWORK_SIZE_VH = '65vh';

interface ArtworkLargeViewProps {
  imageURL : string | null;
  sendImageURL: Function;
  action: Function;
}

const ArtworkLargeView = (props : ArtworkLargeViewProps) => {

  let isInnerClick : boolean = false;

  useOverlay(!!props.imageURL);

  useEffect(() => {
    // Drop any selection the opening click made on the page behind
    if(props.imageURL) window.getSelection()?.removeAllRanges();
  }, [props.imageURL]);

  return props.imageURL? (
  <div onClick={() => {if(isInnerClick){isInnerClick = false}else{props.sendImageURL(null)}}} onMouseDown={preventMultiClickSelection} className={styles.ArtworkLargeView} data-testid="ArtworkLargeView">
    <div onClick={() => {isInnerClick = true}} className={styles.ArtworkLargeViewContainer}>
      <div className={styles.Header}>
        {/* <object data="./close.svg" width="300" height="300"></object> */}
        {/* <img src="close.svg" alt="Close button"/> */}
        <button className={styles.CloseButton} onClick={() => {props.sendImageURL(null)}}><CloseIconPressed className={styles.SVGClose}/></button>
      </div>
      <div className={styles.Content}>
        <img src={props.imageURL} alt="Artwork" style={{ width: ARTWORK_SIZE_VH, height: ARTWORK_SIZE_VH }}/>
      </div>
      <div className={styles.Footer}>
        <Button2 action={() => props.action()}>Buy the artwork</Button2>
      </div>
    </div>
  </div> ) : null
};

export default ArtworkLargeView;

